//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';

// This MUST be loaded before oclazyload!
// It saves the origina angular.bootstrap function so we can bypass ocLazyLoad's
// overridden version when opening UIA
import 'app/initialization/angular/original-bootstrap';

import 'oclazyload';

export default angular.module('curalate.app', ['curalate', 'oc.lazyLoad']);
